import React, { useEffect, useState, useContext } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { handleAuth2RedirectUri } from '../../shared/UtilityFunctions';
import { CmicContext } from '../../context/CmicContext';

const Popup = () => {
	const {
		currentOfficeTheme,
		userInfo,
		showToast,
		setUserInfo,
		resetCMiCData,
		setShowToast,
		setServerType,
		serverType,
		setIsCloudUser,
		isCloudUser,
		removeToast,
	} = useContext(CmicContext);

	const authenticateUser = serverType => {
		return new Promise(async resolve => {
			console.log('serverType', serverType);
			const msalConfig = {
				auth: {
					clientId: 'c371b35c-b9ba-43aa-9629-c33a2860d0a7',
					redirectUri: handleAuth2RedirectUri(),
					authority: `https://login.microsoftonline.com/e6228cf6-a777-498f-b358-3f9b0efaba41`,
					// grant_type: "authorization_code",
				},
				cache: {
					cacheLocation: 'sessionStorage',
					storeAuthStateInCookie: false,
				},
			};

			const msalInstance = new PublicClientApplication(msalConfig);

			try {
				await msalInstance.initialize();

				const data = await msalInstance.loginPopup({ scopes: [`api://outlook.cmicglobaldev.com/Access.Mail`] });

				resolve({ ...data });
			} catch (error) {
				console.error('Login error:', error);
			}
		});
	};

	useEffect(async () => {
		console.log('popups');
		//   window.addEventListener("message", async (event) => {
		//      if(event.data?.serverType){
		//       const authData = await authenticateUser(event.data?.serverType)
		//       window.opener.postMessage(authData, "*");
		//      }
		// });
		let popup = window;
		try {
			const params = new URLSearchParams(popup.location.search);
			const authCode = params.get('code');
			localStorage.setItem('auth_code', authCode);
			console.log(authCode);
			popup.close();

			// Proceed to the token exchange step
			// exchangeAuthCodeForToken(authCode, codeVerifier);
		} catch (error) {
			// Cross-origin frame issues until it redirects back
		}

		//  window.close();
	}, []);

	return (
		<div className="App" style={{ color: 'white' }}>
			<div> window Popup </div>
		</div>
	);
};

export default Popup;
